import React from "react";
import "../Styles/Process.css";
import upImg from "../Assets/service-sidebar-1-1.jpg";
import mainImg from "../Assets/services-6.jpg";
import bottomImg from "../Assets/about-3-1.png";

function Process() {
  return (
    <>
      <div className="process_container">
        <div className="scontainer">
          <div className="row">
            <div
              data-aos="fade-right"
              // data-aos-duration="1500"
              data-aos-mirror="true"
              data-aos-once="false"
              data-aos-easing="ease-in-out"
              className="col-lg-5"
            >
              <div className="process_left">
                <img src={mainImg} alt="mainImg" className="main_img" />
                <img src={upImg} alt="UpImg" className="up_image" />
                <img src={bottomImg} alt="BottomImg" className="bottom_img" />
              </div>
            </div>
            <div
              data-aos="fade-left"
              // data-aos-duration="1500"
              data-aos-mirror="true"
              data-aos-once="false"
              data-aos-easing="ease-in-out"
              className="col-lg-7 pd_70"
            >
              <div className="process_right">
                <p className="service_sub_title">Use the information responsibly</p>
                <h1 className="service_title ">A simple way to use PyLoan</h1>
                <div className="process_detail_container">
                  <div className="process_number">
                    <h1>01</h1>
                  </div>
                  <div className="process_text">
                        <h4>Read a relevant loan guide</h4>
                    <p>
                      Start with the guide that matches your question and note
                      the eligibility factors, documents and repayment points it
                      explains.
                    </p>
                  </div>
                </div>
                <div className="process_detail_container">
                  <div className="process_number">
                    <h1>02</h1>
                  </div>
                  <div className="process_text">
                        <h4>Check the official source</h4>
                    <p>
                      Government scheme rules and lender terms can change. Use
                      the official portal or institution for current details.
                    </p>
                  </div>
                </div>
                <div className="process_detail_container">
                  <div className="process_number">
                    <h1>03</h1>
                  </div>
                  <div className="process_text">
                        <h4>Ask informed questions</h4>
                    <p>
                      PyLoan does not accept applications or make decisions.
                      Take your questions directly to the relevant bank or
                      government authority.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Process;
